<template>
    <zbList v-model="store" class="v-list" v-slot:default="{ item }">
        <div class="item bg-100 bh bstart" :class="item.itemCls" v-on:click="onInfoClick(item)">
            <div class="left bv">
                <div class="name fz_28 bh bstart">
                    <div class="ico bg-contain"></div>
                    <span>&ensp;{{item.couponName}}</span>
                </div>
                <div class="value fz_24">
                    <div>使用时间：</div>
                    <div>{{item.validTime}}-{{item.invalidTime}}</div>
                </div>
            </div>
            <div class="bv b1 right">
                <div class="fz_30 tr exchange">{{item.isExchange}}</div>
                <div class="bh bstart money">
                    <div class="ico bg-contain"></div>
                    <span class="text fwb">{{item.couponDenomination}}</span>
                </div>
            </div>
        </div>
    </zbList>
</template>
<script>
import { getCouponsList, useCoupons } from "@/api/user";
import { list } from "@/mixin/list";
import { user } from "@/mixin/user";
import zbList from "@/components/data/List";
export default {
    mixins: [list, user],
    components: { zbList },
    name: "UserCouponsDiscount",
    props: {
        isLogin: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // 卡券
            store: {
                proxy: {
                    pageParam: "currentPage",
                    getList: getCouponsList,
                    disposeItem(item) {
                        let itemCls = "couponsnormal";
                        // 是否可以兑换
                        const isUse = item.isExchange == "未兑换";
                        if (!isUse) {
                            itemCls = "couponstaboo";
                        }
                        item.isUse = isUse;
                        item.itemCls = itemCls;
                    }
                }
            }
        };
    },
    methods: {
        onInfoClick(item) {
            if (item.isUse) {
                const me = this;
                useCoupons({
                    customerId: me.$store.getters.userInfo.id,
                    couponDetailId: item.id
                }).then(res => {
                    me.storeReLoad();
                    // 获取用户信息
                    me.refreshUser();
                    me.dialog.alert({
                        title: "提示",
                        message: `兑换成功,恭喜您获得${item.couponDenomination}车主币`
                    });
                });
            }
        },
        itemUserLoginend() {
            const me = this;
            me.storeLoad({
                telephone: me.$store.getters.userInfo.telephone
            });
        }
    }
};
</script>
<style scoped lang="scss">
.v-list {
    background-color: #f7f8f8;
    /deep/ .list-item {
        padding: 12px 30px 0 30px;
        &:first-child {
            padding: 24px 30px 0 30px;
        }
        &:last-child {
            padding: 12px 30px;
        }
    }
    .item {
        height: 200px;

        &.couponsnormal {
            background-image: url("~@/assets/imges/user/couponsnormal.png");
            .money {
                .ico {
                    background-image: url("~@/assets/imges/ico/user/moneynormal.png");
                }
            }
            .exchange,
            .text {
                color: #ff9a2b;
            }
        }
        &.couponstaboo {
            color: #aaaaaa;
            background-image: url("~@/assets/imges/user/couponstaboo.png");
            .money {
                .ico {
                    background-image: url("~@/assets/imges/ico/user/moneytaboo.png");
                }
            }
        }
        .left {
            color: #ffffff;
            width: 379px;
            .name {
                padding: 30px 0 25px 30px;
            }
            .value {
                line-height: 30px;
                padding: 0 0 30px 30px;
            }
            .ico {
                background-image: url("~@/assets/imges/ico/user/car.png");
                width: 46px;
                height: 38px;
                margin-right: 10px;
            }
        }
        .right {
            .exchange {
                padding-right: 23px;
                height: 29px;
                line-height: 29px;
            }
            .money {
                height: 90px;
                line-height: 90px;
                .ico {
                    width: 67px;
                    height: 71px;
                }
                .text {
                    margin-left: 10px;
                    font-size: 80px;
                }
            }
        }
    }
}
[data-theme="app"] {
    .v-list {
        .item {
            &.couponsnormal {
                background-image: url("~@/assets/imges/app/user/couponsnormal.png");
                .money {
                    .ico {
                        background-image: url("~@/assets/imges/app/ico/moneynormal.png");
                    }
                }
                .exchange,
                .text {
                    color: #c30d23;
                }
            }
        }
    }
}
</style>
